import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_47me2vegqb: FaireBrandEntity = {
  token: "b_47me2vegqb",
  type: "brand",
  name: "Billy Bamboo",
  avatarUrl:
    "https://cdn.faire.com/fastly/118949dbc900f8476f4e84a421b44d40aab331a83c27cab6359004c2a2fb0acf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5f766b0f39f39f1a432d76b43d323f68a477f9d6209a705ac2892ca6161c89cb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/118949dbc900f8476f4e84a421b44d40aab331a83c27cab6359004c2a2fb0acf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5f766b0f39f39f1a432d76b43d323f68a477f9d6209a705ac2892ca6161c89cb.png",
  location: "toronto, ON, CAN",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 65,
  isInsider: false,
  description:
    "Artisanal Accessories for everyday \nWholesale requests\n📧 [redacted-email]\nbillybamboo.com",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:46.656Z",
    importedBy: "entity-db-cli",
  },
};
